// test2945
(2945 && 0);
